import { Controller } from '@hotwired/stimulus';

export default class PreviewController extends Controller {
  static targets = ['source', 'output'];

  static values = { videoUrl: String };

  connect() {
    this.syncAll();
  }

  disconnect() {
    if (this.uploadedVideoUrl) URL.revokeObjectURL(this.uploadedVideoUrl);
  }

  mirror() {
    this.syncAll();
  }

  uploadVideo(event) {
    const file = event.target.files[0];
    if (this.uploadedVideoUrl) URL.revokeObjectURL(this.uploadedVideoUrl);

    this.uploadedVideoUrl = file ? URL.createObjectURL(file) : null;

    this.sourceTargets
      .filter((s) => s.dataset.previewMode === 'html')
      .forEach((s) => this.syncSource(s));
  }

  syncAll() {
    this.sourceTargets.forEach((source) => this.syncSource(source));
  }

  syncSource(source) {
    const name = source.dataset.previewName;
    if (!name) return;

    const mode = source.dataset.previewMode;
    let value;

    if (mode === 'html') {
      const hidden = source.querySelector('input[type="hidden"]');
      value = hidden ? this.processVideo(hidden.value) : '';
    } else {
      value = source.value || '';
    }

    this.outputTargets
      .filter((o) => o.dataset.previewName === name)
      .forEach((output) => {
        if (mode === 'html') {
          output.innerHTML = value;
        } else {
          output.textContent = value;
        }
      });
  }

  processVideo(html) {
    if (!html || !html.includes('[VIDEO]')) return html || '';

    const videoUrl = this.uploadedVideoUrl || this.videoUrlValue || '#';
    return html.replace(/\[VIDEO\]/g, `<a href="${videoUrl}">VIDEO</a>`);
  }
}
